// This file was generated using `pay js:run gql-v1 --type=lazy-query --name=GetIdentityChallengeExternalAccountKey --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import type {
  V1LazyQueryOptionsWithoutVariables,
  V1LazyQueryOptions,
  V1LazyQueryReturn,
  V1PermissionToken,
} from '@stripe-internal/data-v1/types';
import {useV1LazyQuery} from '@stripe-internal/data-v1';
import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiGetV1ConnectIdentityChallengesAuthAttemptIdExternalAccountKeyInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  query GetIdentityChallengeExternalAccountKeyQuery(
    $input: OpenapiGetV1ConnectIdentityChallengesAuthAttemptIdExternalAccountKeyInput
    $v1Context: V1ContextInput!
  ) {
    v1ConnectIdentityChallengesAuthAttemptIdExternalAccountKey(
      input: $input
      v1Context: $v1Context
    ) {
      key
    }
  }
`;

export const getIdentityChallengeExternalAccountKeyLazyQuery: GetIdentityChallengeExternalAccountKeyLazyQueryDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const getIdentityChallengeExternalAccountKeyLazyQueryOptions: V1LazyQueryOptionsWithoutVariables<GetIdentityChallengeExternalAccountKeyLazyQueryDocument> =
  {
    expectedErrors: [
      'identity_challenge_expired',
      'identity_challenge_not_passed',
    ],
    // mutedErrors: [],
    // fetchPolicy: 'cache-first',
    // ...
  };

export default function useGetIdentityChallengeExternalAccountKeyLazyQuery(
  options: V1LazyQueryOptions<GetIdentityChallengeExternalAccountKeyLazyQueryDocument> = {},
): V1LazyQueryReturn<GetIdentityChallengeExternalAccountKeyLazyQueryDocument> {
  return useV1LazyQuery(
    getIdentityChallengeExternalAccountKeyLazyQuery,
    Object.assign(
      {},
      getIdentityChallengeExternalAccountKeyLazyQueryOptions,
      options,
    ),
  );
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type GetIdentityChallengeExternalAccountKeyLazyQueryVariables = Exact<{
  input?: InputMaybe<OpenapiGetV1ConnectIdentityChallengesAuthAttemptIdExternalAccountKeyInput>;
  v1Context: V1ContextInput;
}>;

export type GetIdentityChallengeExternalAccountKeyLazyQueryData = {
  readonly __typename: 'Query';
  readonly v1ConnectIdentityChallengesAuthAttemptIdExternalAccountKey: {
    readonly __typename: 'OpenapiConnectAuthResourcesIdentityChallengeGetKey';
    readonly key: string;
  } | null;
};

const getIdentityChallengeExternalAccountKeyLazyQueryPermissions = {} as const;

doc.permissions = getIdentityChallengeExternalAccountKeyLazyQueryPermissions;

export type GetIdentityChallengeExternalAccountKeyLazyQueryPermissions =
  V1PermissionToken<
    typeof getIdentityChallengeExternalAccountKeyLazyQueryPermissions
  >;

export type GetIdentityChallengeExternalAccountKeyLazyQueryDocument =
  GraphQlDocument<
    GetIdentityChallengeExternalAccountKeyLazyQueryData,
    GetIdentityChallengeExternalAccountKeyLazyQueryVariables,
    GetIdentityChallengeExternalAccountKeyLazyQueryPermissions
  >;
